﻿export interface IPhone {
    id: string;
    userId: string;
    phoneTypeCId: number;
    phoneNumber:string;
}

export class Phone implements IPhone {
    id: string;
    userId: string;
    phoneTypeCId: number;
    phoneNumber: string;
}
